import React, { useRef, useState } from "react";
import { View, StyleSheet, TouchableOpacity, Image } from "react-native";
import { useNavigation } from "@react-navigation/native";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from "react-native-popup-menu";
import LinearGradient from "react-native-linear-gradient";

import Text from "@components/AppText";
import colors from "@constants/color";
import KebabIcon from "@assets/svg/Kebab";
import DeleteIcon from "@assets/svg/DeleteIcon";
import t from "@constants/localization";
import DeleteCXModal from "@components/DeleteCXModal";
import BackArrow from "@assets/svg/BackArrow";
import { scale, verticalScale } from "@utils/scale";

const PATH = "screens/CustomerProfile/TopSection";

const TopSection = ({ address, user }) => {
  const navigation = useNavigation();
  const modalRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const deleteClCustomer = () => {
    setIsMenuOpen(false);
    modalRef.current.showModal();
  };

  return (
    <View>
      <LinearGradient
        style={styles.topContainer}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={[colors.profileGrad1, colors.profileGrad2]}
      >
        <View style={[styles.itemsAsRow, { justifyContent: "space-between" }]}>
          <View style={styles.itemsAsRow}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              <BackArrow color="#fff" />
            </TouchableOpacity>
            <View style={{ padding: 5 }}>
              {user && user.user_image ? (
                <Image
                  style={{
                    width: scale(32),
                    height: scale(32),
                    borderColor: "white",
                    borderWidth: 1,
                    borderRadius: scale(25),
                  }}
                  source={{ uri: user.user_image }}
                />
              ) : (
                <Image
                  style={{ width: scale(32), height: scale(32) }}
                  source={require("../../assets/images/UserProfile.webp")}
                />
              )}
            </View>
            <Text
              bold
              fontType="head1"
              numberOfLines={1}
              style={{ color: colors.white, marginLeft: 10, width: "70%" }}
            >
              {(user && user.user_name) || ""}
            </Text>
          </View>

          <Menu
            opened={isMenuOpen}
            onBackdropPress={() => setIsMenuOpen(false)}
          >
            <MenuTrigger onPress={() => setIsMenuOpen(true)}>
              <KebabIcon color="#fff" />
            </MenuTrigger>
            <MenuOptions optionsContainerStyle={{ padding: 10 }}>
              <MenuOption onSelect={deleteClCustomer}>
                <View style={{ flexDirection: "row", paddingBottom: 10 }}>
                  <DeleteIcon />
                  <Text
                    fontType="content1"
                    style={{ color: colors.mediumBlack, marginLeft: 10 }}
                  >
                    {t(`${PATH}/deleteCustomer`)}
                  </Text>
                </View>
              </MenuOption>
            </MenuOptions>
          </Menu>
        </View>
      </LinearGradient>
      <DeleteCXModal ref={modalRef} {...{ user, navigation }} />
    </View>
  );
};

const styles = StyleSheet.create({
  topContainer: {
    height: verticalScale(180),
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 10,
    paddingTop: verticalScale(60),
  },
  itemsAsRow: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default TopSection;
